import { inKwaiying } from '@/utils/device';
import crypto from '@/utils/crypto';
import axios from 'axios';
import { getCookie } from "@/utils/cookie";
import { getUrlParam } from '@/utils/url';

axios.defaults.timeout = 5000;
axios.defaults.withCredentials = true;

axios.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        return Promise.reject(error);
    }
);

const baseUrlMap = process.env.KyApi;
const HOST = window.location.hostname.indexOf('kittyfunny.com') > -1 ? "https://g-api.kittyfunny.com" : window.location.hostname.indexOf('kwaiying.com') > -1 ? 'https://ky-api.kwaiying.com' : (baseUrlMap.HOST || 'https://api.kmovie.gifshow.com');
// const HOST = 'https://preonline-kmovie-api.test.gifshow.com'

// post 请求
export function post(url, data = {}) {
    const did =  getCookie('did') || getCookie('_did');
    return axios({
        method: 'post',
        url: `${HOST}${url}`,
        data: {
            did: inKwaiying() ? did : getUrlParam('tk'),
            webId: did,
            ...data,
        },
        headers: { 'Content-Type': 'application/json' },
        params: crypto('yiuhjkbvhbjisjchgdnx38uejd'),
    });
}

// get请求
export function get(url, query = {}) {
    const did =  getCookie('did') || getCookie('_did');
    return axios({
        method: 'get',
        url: `${HOST}${url}`,
        params: {
            did: inKwaiying() ? did : getUrlParam('tk'),
            webId: did,
            userId:getCookie('userId'),
            'ky.api_st': getCookie('ky.api_st'),
            ...query,
            ...crypto('yiuhjkbvhbjisjchgdnx38uejd'),
        },
    });
}

// 脱敏处理
export function encryptionKey(str,type){
    if(str == '无' || !str){
        return '无'
    }
    let formalStr = '无';
    let array = [];
    switch(type){
        case 'phone':
            formalStr = str.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
            break;
        case 'ip':
            if(str){
                array = str.split('.')
            }
            formalStr = `${array[0]}.${array[1]}.*.*`;
            break;
        case 'did':
            formalStr = `${str.slice(0,4)}****${str.slice(str.length-4)}`;
            break;
    }
    return formalStr;
}